import axiosInstance from 'src/common/axiosInstance';

// AUTO-CRM-32: company and personal targets (see the backend's TargetController).
const data = (response) => response.data;

export const listTargets = (date) => axiosInstance.get('/targets', { params: date ? { date } : {} }).then(data);
export const targetOptions = () => axiosInstance.get('/targets/options').then((response) => response.data?.data);
export const createTarget = (body) => axiosInstance.post('/targets', body).then(data);
export const updateTarget = (id, body) => axiosInstance.patch(`/targets/${id}`, body).then(data);
export const deleteTarget = (id) => axiosInstance.delete(`/targets/${id}`).then(data);
export const getRecap = ({ scope = 'company', days = 1, date } = {}) => axiosInstance.get('/targets/recap', { params: { scope, days, ...(date ? { date } : {}) } }).then((response) => response.data?.data);
